import { AuthProvider } from '@sdk/authentication/AuthContext';

import { UserSettingsProvider } from '@web/settings/UserSettingsContext';
import { UserOrgSettingsProvider } from '@web/settings/UserOrgSettingsContext';
import ChooseBreakTypeModal from '@web/timeClock/ChooseBreakTypeModal/ChooseBreakTypeModal';

const ChooseBreakTypeModalAngular = ({
  shift,
  onStartBreak,
  useWhiteBg,
  useBtn150,
  Authentication,
}) => (
  <AuthProvider currentUser={Authentication.user}>
    <UserSettingsProvider settings={Authentication.user.settings}>
      <UserOrgSettingsProvider settings={Authentication.user.orgSettings}>
        <ChooseBreakTypeModal
          shift={shift}
          onStartBreak={onStartBreak}
          useWhiteBg={useWhiteBg}
          useBtn150={useBtn150}
        />
      </UserOrgSettingsProvider>
    </UserSettingsProvider>
  </AuthProvider>
);

export default {
  ReactComponent: ChooseBreakTypeModalAngular,
  dependencies: ['Authentication'],
  bindings: {
    shift: '<',
    onStartBreak: '&',
    useWhiteBg: '<',
    useBtn150: '<',
  },
};
